<template>
  <div>
    <bread-crumb2 :menu="{name: '쿠폰 발행 내역',
    desc: '회원에게 발행한 쿠폰 내역들을 관리할 수 있습니다.'}"></bread-crumb2>
    <div class="columns is-multiline">
      <div class="column is-9">
        <admin-filter
          :items="filterData"
          :itemFiltered.sync="filtered"
          @getData="getDataFromServer"
          title="쿠폰 발행 내역"
          desc="발행 내역들의 현황을 조회할 수 있습니다."
        ></admin-filter>
      </div>
      <div class="column is-3">
        <div class="box" v-if="value!==undefined">
          <admin-box-item title="쿠폰 내용">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="쿠폰명">
                  {{ value.name }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="쿠폰설명">
                  {{ value.name }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="사용가능일 제한 날짜">
                  {{ endDate(value) }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="발행유형">
                  <div v-if="value.publish_type===0">수동발행</div>
                  <div v-else>조건부 자동 발행</div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="할인">
                  <!-- 할인 비율 -->
                  <div v-if="value.discount_type===0">{{ value.discount_rate }}% 할인</div>
                  <!-- 할인 가격 -->
                  <div v-else-if="value.discount_type===1">{{ value.discount_price }}원 할인</div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">삭제하기</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="enable_use" slot-scope="props">
        <div v-if="props.item.enable_use">사용가능</div>
        <div v-else>사용불가능</div>
      </div>

      <div slot="partner" slot-scope="props">
        <div v-if="props.item.user.partner">파트너 담당자</div>
        <div v-else>일반 회원</div>
      </div>

      <div slot="name" slot-scope="props">{{ props.item.user.name }}</div>

      <div slot="phone" slot-scope="props">{{ props.item.user.phone }}</div>

      <div slot="email" slot-scope="props">{{ props.item.user.email }}</div>

      <div slot="gender" slot-scope="props">
        <div v-if="props.item.user.gender==='femail'">여</div>
        <div v-else>남</div>
      </div>



      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import BreadCrumb2 from "../../module/common/BreadCrumb2";
  export default {
    components: {
      BreadCrumb2,
      LpCheckBool},
    name: "UserCouponList",
    mixins: [
      ListMixin
    ],
    data() {
      return {
        value: undefined
      }
    },
    created() {
      this.init();
    },
    methods: {
      endDate(item) {
        if(item.limit_type===0) {
          // return moment(item.created_time).add(item.few_day).format('YYYY-MM-DD');
          return `쿠폰 받은 날로 부터 ${item.few_day}일 이내 사용`
        }
        else if(item.limit_type===1) {
          return item.end_date;
        }
        else if(item.limit_type===2) {
          return `${item.coupon_start} ~ ${item.coupon_end}`;
        }
        else {
          return '없음';
        }
      },
      init() {
        this.initializing('user_coupon_issue', `coupon/${this.$route.query.id}/user`);
        this.getCouponDetail();
      },
      getDataFromServer() {
        this.getData();
      },
      getCouponDetail() {
        this.$axios.get(this.getUrl(`coupon/${this.$route.query.id}`)).then(res=> {
          this.value = res.data;
        })
      },
      saveData() {
        let id_list = this.getCheckedArr();
        if(id_list.length===0) {
          this.toast('삭제할 대상을 선택하세요.');
          return;
        }
        this.$axios.delete(this.getUrl(`coupon/${this.$route.query.id}/user/delete/multiple`), {
          data: {
            user_coupons: id_list
          }
        }).then(res=> {
          this.toast('삭제가 완료되었습니다.');
          this.$router.replace(this.getPath('coupon'));
        })
      }
    }
  }
</script>

<style scoped>

</style>
